import { customerAreaPrefix } from "~/config";

export default defineNuxtRouteMiddleware(() => {
  if (useCustomerStore().isExclusivelyTenantPowerCustomer) {
    return navigateTo(customerAreaPrefix);
  }
});
